import styled, { css } from 'styled-components';
import { screenXsMax, screenSmMin, spacer16, spacer24, spacer40, } from '@spotify-internal/encore-web';
export const Box = styled.div `
  ${({ flex }) => flex &&
    css `
      flex: ${flex};
    `}

  ${({ noPadding }) => !noPadding &&
    css `
      @media (max-width: ${screenXsMax}) {
        padding: ${spacer24} ${spacer16};
      }

      @media (min-width: ${screenSmMin}) {
        padding: ${spacer24} ${spacer40};
      }
    `}

  ${({ theme }) => css `
      background: ${theme.box.background};
      color: ${theme.box.text};
    `}

  ${({ transparent }) => transparent &&
    css `
      background: transparent;
    `}
`;
